import React from "react";

import { faVideo } from "@performyard/fontawesome/pro-solid-svg-icons";
import { Icon, Text, TextDate } from "@performyard/py-components";

import { getVideoConferencingProviderShortName } from "../../../../api/hooks";

type TranscriptSourceNotationProps = {
	/** Provider the transcript was auto-retrieved from (e.g. "zoom"). */
	source: string;
	/** ISO timestamp of when it was retrieved. */
	retrievedAt: string;
};

/** "From {provider} · {time}" provenance caption shown below an auto-retrieved transcript. */
const TranscriptSourceNotation = ({ source, retrievedAt }: TranscriptSourceNotationProps): React.ReactElement => {
	const providerDisplayName = getVideoConferencingProviderShortName(source);

	return (
		<div className="flex items-center gap-1">
			<Icon icon={faVideo} size={16} color="neutral-7" aria-hidden="true" />
			<Text size="paragraph-3" weight="semi-bold" color="neutral-7">
				From {providerDisplayName}
			</Text>
			<Text size="paragraph-3" weight="regular" color="neutral-7">
				·
			</Text>
			<TextDate date={new Date(retrievedAt)} hasTime compactTime dateSize="medium" color="neutral-7" />
		</div>
	);
};

export default TranscriptSourceNotation;
